import { render } from "./AdministrationPage.vue?vue&type=template&id=6d5adb51&scoped=true"
import script from "./AdministrationPage.vue?vue&type=script&lang=js"
export * from "./AdministrationPage.vue?vue&type=script&lang=js"

import "./AdministrationPage.vue?vue&type=style&index=0&id=6d5adb51&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5adb51"]])

export default __exports__